import { Defaults } from 'es-decorators'
import { View } from 'es6/components/view'
import { ChoiceCityItemView } from 'es6/views/choice-city/choice-city-item-view'
import { RemoteItemsPopupView } from 'es6/views/popups/remote-items-popup-view'
import { getCookie, setCookie } from 'helpers/cookie-helper'
import { getTemplate } from 'helpers/template-helper'
import { getDomain } from 'helpers/url-helpers'
import { isMobile } from 'init/is-mobile'
import { jsonFeatures } from 'init/json-features'
import isArray from 'lodash/isArray'
import Backbone from 'init/backbone'
import { FastDeliveryPopupView } from 'es6/views/popups/fast-delivery-popup-view'
import { LOCALES } from '../constants'
import locale from 'init/locale'
import $ from 'init/jquery'
import { getFormattedPhoneNumber } from '../../helpers/tel-helpers'
import { CQC_COMMAND_TYPES, CQC_COMMAND_EVENT } from 'es6/constants'
import { UserCurrent } from 'es6/models/user-current'

/**
 * Общий вид для всей страницы.
 */
@Defaults({
  el: 'body',
  events: {
    'click .mature': 'setMature',
    'click .to-authorisation': 'toAuthorisation',
    'click .to-registry': 'toRegistry',
    'click .not-mature': 'toTop',
    'click .b-home-chponck__close': 'closeTopBanner',
    'click .top-error-chponck .js-popup-close': 'closeGlobalError',
    'click .back-link': 'back',
    'click .mt-no-auth-btn': 'redirectToNews',
    'click': 'triggerClickEvent',
  },
  globalErrorTemplate: '#top-error-chponk-template',
  /** Перезаписать параметры ссылок при запуске */
  autoRewritePageLinks: true,
  additionalOptions: ['jsView'],
})
export class BodyView extends View {
  /**
   * @inheritDoc
   */
  run () {
    this.setChoiceCityForms()
    setTimeout(() => {
      if (this.autoRewritePageLinks) {
        this.rewritePageLinks()
      }
    }, 1)

    this.listenTo(Backbone, 'block-screen', this.toggleScrollLock)
    this.listenTo(Backbone, 'global-error', this.showGlobalError)
    this.listenTo(this.router, 'change-get-params', this.rewritePageLinks)
    if (!isMobile && locale === LOCALES.ru) {
      this.globalErrorTemplate = getTemplate(this.globalErrorTemplate)
      if (!this.$('.top-error-chponck').length) {
        this.$('div[data-jsview]').before(this.globalErrorTemplate())
      }
      this._initParser()
    }
    if (!isMobile
      && !getCookie('isRemotePopupShown')
      && jsonFeatures.is_remote_items_popup_enabled) {
      this.childViews.remoteitemsPopupView = new RemoteItemsPopupView({
        settlement: this.settlement,
        cart: this.cart,
      })
    }
    if (!isMobile) {
      this.childViews.fastDeliveryPopup = new FastDeliveryPopupView()
    }
    if (this.settlement) {
      this.toggleBodyClassRemoteDisable()
      this.listenTo(this.settlement, 'change', this.toggleBodyClassRemoteDisable)
    }
    const phoneNumbers = $('.js-need-format-phone')
    if (phoneNumbers.length) {
      this.formatPhoneNumbers(phoneNumbers)
    }
    this.userCurrent = new UserCurrent()
  }

  /**
   * @inherited
   */
  afterRun () {
    this.topChponck = this.$('.b-home-chponck')
    this.topChponckIsClosed = this.topChponck.length && this.topChponck.hasClass('not_display')
  }

  /**
   * Создаем вьюхи для работы с формами выбора города.
   */
  setChoiceCityForms () {
    this.childViews.choiceCityItems = []
    this.$('.choice-city').each((index, el) => {
      this.childViews.choiceCityItems.push(
        new ChoiceCityItemView({
          el: $(el),
          user: this.user,
          settlement: this.settlement,
        })
      )
    })
  }
  /**
   * Скроллит в верх страницы
   */
  toTop () {
    $('html,body').animate({ scrollTop: 0 }, 'slow')
  }
  /**
   * Устанавливает параметр совершеннолетия пользователя.
   */
  setMature () {
    if (!this.user.get('is_mature')) {
      const isAdultForEveryone = jsonFeatures.is_adult_for_everyone_enabled;
      if (isAdultForEveryone) {
        this.userCurrent.set({is_mature: 1})
        this.userCurrent.sync('update', this.userCurrent, {is_mature: 1})
      } else {
        this.user.set({is_mature: 1, scenario: 'api-confirmation'})
        this.user.save()
      }
      this.$('.item-protected-blank').addClass('not_display')
      $('body').removeClass('not-mature')
    }
  }
  /**
   * Открывает окно авторизации.
   */
  toAuthorisation () {
    Backbone.trigger(CQC_COMMAND_EVENT, { type: CQC_COMMAND_TYPES.showAuthForm })
  }
  /**
   * Открывает окно регистрации.
   */
  toRegistry () {
    Backbone.trigger(CQC_COMMAND_EVENT, { type: CQC_COMMAND_TYPES.showRegistrationForm })
  }
  /**
   * Закрывает баннер-перетяжку с сохранением в cookies
   */
  closeTopBanner () {
    let chponckId = this.topChponck.data('chponck-id'),
      closedChponcks = isArray(getCookie('top_chponck_is_closed'))
        ? getCookie('top_chponck_is_closed')
        : []
    $('.wait-sec-pls').addClass('not_display')
    this.topChponck.addClass('not_display')
    this.topChponckIsClosed = true
    if (closedChponcks.indexOf(chponckId) === -1) {
      closedChponcks.push(chponckId)
      setCookie('top_chponck_is_closed', closedChponcks, {
        domain: '.' + getDomain(),
        path: '/',
        expires: 31536000,
      })
    }
  }

  /**
   * Переход на предыдущую страницу
   */
  back () {
    window.history.back()
  }
  /**
   * Показывает попап глобальной ошибки
   * @param {Object} data Данные ошибки
   */
  showGlobalError (data) {
    if (this.$('.top-error-chponck').length) {
      if (data && data.error) {
        this.$('.top-error-chponck .global-errors').html(data.error).removeClass('not_display')
        if (this.$('.top-error-chponck').outerHeight() === 0) {
          $('html, body').animate({ scrollTop: 0 }, 500, () => {
            this.$('.top-error-chponck').animate({ height: this.$('.top-error-message').outerHeight() + 'px' }, 350, () => {
              $(this).css({ height: 'auto' })
            })
          })
        }
      }
    }
  }
  /**
   * Скрывает попап глобальной ошибки
   */
  closeGlobalError () {
    if (this.$('.top-error-chponck').outerHeight() > 0) {
      this.$('.top-error-chponck').animate({ height: '0px' }, 350, () => {
        this.$('.top-error-chponck .global-errors').html('').addClass('not_display')
      })
    }
  }
  /**
   * Инициализация Parser в зависимости от данных пользователя.
   * @private
   */
  _initParser () {
    let allowedViews = ['category', 'search', 'wish', 'order', 'cart']
    if (this.jsView && _.includes(allowedViews, this.jsView)) {
      if (this.user.get('is_cloudparser_enabled')) {
        this._addScript('//cloudparser.ru/widget/script?hash=356a192b7913b04c54574d18c28d46e6395428ab')
      }
    }
  }
  /**
   * Добавляем скрипт на страницу.
   *
   * @param {string} url
   * @private
   */
  _addScript (url) {
    let script,
      head
    script = document.createElement('script')
    head = document.getElementsByTagName('head')[0]
    script.type = 'text/javascript'
    script.src = url
    head.appendChild(script)
  }

  /**
   * Поставить класс 'remote-disable' на body если не доступны товары партнеров.
   * Убрать, если в России.
   * Не меняем класс если это регион с возможностью заказа мелкого опта (is_small_wholesale)
   */
  toggleBodyClassRemoteDisable () {
    if (!this.settlement.get('is_small_wholesale')) {
      this.$el.toggleClass('remote-disable', !this.settlement.isRemoteStoreEnabled())
    }
  }

  /**
   * Триггер события при клике на this.el
   * @param {Event} e
   */
  triggerClickEvent (e) {
    Backbone.trigger('bodyView:click', e)
  }

  /**
   * Форматирует телефонные номера на странице
   * @param {jQuery} phoneNumbers - элементы с телефонными номерами
   */
  formatPhoneNumbers (phoneNumbers) {
    phoneNumbers.each((id, phoneNumber) => {
      const $phoneNumber = $(phoneNumber)
      const newNumber = getFormattedPhoneNumber($phoneNumber.text(), true)
      $phoneNumber.text(newNumber)
    })
  }

  /**
   * Переключает класс блокировки скролла на странице.
   * @param {string} [className=body-hidden] Класс для body.
   * @param {boolean} [isUnscrollable] Признак блокировки скролла.
   */
  toggleScrollLock (className = 'body-hidden', isUnscrollable) {
    if (arguments.length === 1) {
      isUnscrollable = !this.$el.hasClass(className)
    }
    this.$el.toggleClass(className, isUnscrollable)
  }
}
